export const getAgencyLanguagesUrl = () => '/agency/languages';
